import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Container, IconButton, Typography, Fade } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import NavBar from '../../Components/NavBar/navbar';
import FooterSection from '../../Components/Footer/footer';
import { gamesData } from '../../Components/Arcade/gamesConfig';

const GamePage = () => {
    const { gameId } = useParams();
    const navigate = useNavigate();

    const selectedGame = gamesData.find(g => g.id === gameId);

    if (!selectedGame) {
        return (
            <Box sx={{ bgcolor: '#0a0a0a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography variant="h5" color="white">Game not found</Typography>
            </Box>
        );
    }

    const GameComponent = selectedGame.component;

    return (
        <Box sx={{ bgcolor: '#0a0a0a', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <NavBar />

            <Box sx={{ flexGrow: 1, pt: 10, pb: 4 }}>
                <Container maxWidth="xl">
                    <Fade in timeout={600}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <IconButton
                                onClick={() => navigate('/arcade?section=games')}
                                aria-label="Back to arcade"
                                sx={{
                                    mr: 2,
                                    backgroundColor: 'rgba(255,255,255,0.05)',
                                    border: '1px solid #333',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'rgba(255,255,255,0.1)',
                                        transform: 'translateX(-4px)',
                                    },
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <ArrowBack />
                            </IconButton>
                            <Typography variant="body2" sx={{ color: '#71717a' }}>
                                {selectedGame.genre} · {selectedGame.difficulty}
                            </Typography>
                        </Box>
                    </Fade>
                </Container>

                <Fade in timeout={900}>
                    <Box>
                        <GameComponent />
                    </Box>
                </Fade>
            </Box>

            <FooterSection />
        </Box>
    );
};

export default GamePage;
